import { ACCOUNT_BALANCE_FIELDS, } from './account-balance-fields.js';
const ACCOUNT_BALANCE_FIELD_SET = new Set(ACCOUNT_BALANCE_FIELDS);
/**
 * Campo saldo/fido di un conto. Vale anche per i valori di
 * `restore-bank-fields` (fido e scadenza dello scoperto), che si chiamano come
 * i campi del conto.
 */
export function isAccountBalanceField(field) {
    return ACCOUNT_BALANCE_FIELD_SET.has(field);
}
/**
 * Input di create/update conto senza i campi saldo e fido: chi non vede i
 * saldi non può modificarli, e un salvataggio non deve azzerare quello che
 * non ha potuto leggere (il backend aggiorna ogni chiave presente, anche a
 * null). Pura: restituisce una copia. Usata da API (scrittura) e webapp
 * (payload del form).
 */
export function omitAccountBalanceInput(input) {
    const entries = Object.entries(input).filter(([key]) => !isAccountBalanceField(key));
    return Object.fromEntries(entries);
}
//# sourceMappingURL=account-balance-input.js.map